<script>
// 抽象组件没有实际的DOM元素，所以也就没有template模板，
// 它会有一个render函数，我们就来看看里面进行了哪些操作。


// 获取组件名称
function getComponentName(opts) {
  return opts && (opts.Ctor.options.name || opts.tag);
}

// 移除数组中某个值
function remove(arr, item) {
  if (arr.length) {
    const index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
}

// 是否包含
function matches(pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1;
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1;
  }
  return false;
}

// 执行删除缓存
function pruneCacheEntry(cache, key, keys, currentVNode) {
  const cached = cache[key];
  if (cached && (!currentVNode || cached.tag !== currentVNode.tag)) {
    cached.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

// 处理缓存
function pruneCache(_this, pattern) {
  const { cache, keys, _vnode } = _this;
  for (const key in cache) {
    const cachedNode = cache[key];
    if (cachedNode) {
      const name = getComponentName(cachedNode.componentOptions);
      const isContains = matches(pattern, name); // (include)里面存在吗
      if (name && !isContains) {
        // 删除缓存()
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

export default {
  name: 'keep',
  abstract: true, // 标识当前的组件是一个抽象组件
  props: {
    include: [String, Array],
    refresh: [String, Boolean],
  },
  created() {
    this.cache = Object.create(null);
    this.keys = [];
  },
  mounted() {
    this.$watch('include', (val) => {
      pruneCache(this, val);
    });
  },
  render() {
    const vnode = this.$slots.default && this.$slots.default.filter(c => c && c.componentOptions)[0]; // 获取第一个元素。
    const opts = vnode && vnode.componentOptions; // 获取组件属性
    if (opts) {
      const name = getComponentName(opts); // 获取组件名称
      // 如果没有在include里面
      if (this.include && (!name || !matches(this.include, name))) {
        return vnode;
      }
      const key = vnode.key == null ? opts.Ctor.cid + (opts.tag ? `::${opts.tag}` : '') : vnode.key; // 获取组件key
      if (this.cache[key] && !this.refresh) {
        vnode.componentInstance = this.cache[key].componentInstance;
        remove(this.keys, key);
        this.keys.push(key);
      } else {
        this.cache[key] = vnode;
        this.keys.push(key);
      }
      vnode.data.keepAlive = true;
    }
    return vnode || (this.$slots.default && this.$slots.default[0]);
  },
  destroyed() {
    for (const key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },
};

</script>



// WEBPACK FOOTER //
// src/components/keep.vue